import React from "react";
import { ArtistMessage } from "../../types/ArtistMessage";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { format, getLetter } from "../../components/text-helper/text-helper";
import HighlightedText from "./HighlightedText";
import "./Search.scss";

interface ArtistSearchResultProps {
    index: number;
    searchText: string;
    artistMessage: ArtistMessage;
}

const ArtistSearchResult = (props: ArtistSearchResultProps) => {    
    return (
        <Box component={Link}
            className="search-result"
            key={`$artist-${props.index}`}
            to={`/letters/${getLetter(props.artistMessage.name)}/artists/${props.artistMessage.name}`}
        >
            <HighlightedText searchText={props.searchText} term={format(props.artistMessage.name)} />
        </Box>
    );
}

export default ArtistSearchResult;